export default __webpack_public_path__ + "alberta-interval.8516b4931e96d631b8c9.svg";